import { Outlet } from 'react-router-dom';

const SoporteCorporativoModule: React.FC = () => {
  return <Outlet />;
};

export default SoporteCorporativoModule;
